import PropTypes from 'prop-types'
import { Fragment } from 'react'

const MedioDePago = ({ mediosPago }) => {
  return (
    <>
      {mediosPago &&
        mediosPago.map((m) => (
          <Fragment key={m.idMedioPago}>
            <i className={m.icono} title={m.nombre} aria-hidden="true" /> &nbsp;
          </Fragment>
        ))}
    </>
  )
}

MedioDePago.propTypes = {
  mediosPago: PropTypes.arrayOf(
    PropTypes.shape({
      idMedioPago: PropTypes.number,
      icono: PropTypes.string,
      nombre: PropTypes.string
    })
  ).isRequired
}

export default MedioDePago
